class EqualHeights {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-equal-heights="scope"]',
			item: '[data-equal-heights="item"]',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		let observer = new ResizeObserver(this.handleResize.bind(this));

		this.$scope.each((index, scope) => {
			observer.observe(scope);
		});
	}

	handleResize(entries, observer) {
		for (let scope of entries) {
			let $scope = $(scope.target);
			$scope.data('timeout') ? clearTimeout($scope.data('timeout')) : null;
			$scope.data('timeout', setTimeout(() => {
				this.removeHeight($scope)
				this.setHeight($scope)
			}, 50));
		}
	}

	removeHeight($scope) {
		$scope.find(this.config.item).css('height', '');
	}

	setHeight($scope) {
		let $items = $scope.find(this.config.item);
		let height = 0;

		$items.each((index, item) => {
			let $item = $(item);
			if ($item.outerHeight() > height) {
				height = $item.outerHeight();
			}
		});

		$items.css('height', height + 'px');
	}
}

export default EqualHeights;